import React from "react";
import { useNavigate } from "react-router-dom";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CancelIcon from "@mui/icons-material/Cancel";

import PrimaryButton from "../../../widgets/Buttons/PrimaryButton";
import SecondaryButton from "../../../widgets/Buttons/SecondaryButton";
import routes from "../../../constants/routes";
import styles from "../StudentDetails.module.scss";

const OrderManagementCard = ({ uamId, phone, vertical }) => {
  const navigate = useNavigate();

  const handleManageOrder = () => {
    if (!uamId) return;
    navigate(routes.modifyOrder.replace(":studentId", uamId), {
      state: { uamId, phone, vertical },
    });
  };

  const handleCancelOrder = () => {
    if (!uamId) return;
    navigate(routes.cancelOrder.replace(":studentId", uamId), {
      state: { uamId, phone, vertical },
    });
  };

  return (
    <>
      <PrimaryButton
        className={`${styles.actionButtonLarge} ${styles.actionButtonNeutral}`}
        startIcon={<ReceiptIcon />}
        onClick={handleManageOrder}
      >
        Order Modification
      </PrimaryButton>
      <SecondaryButton
        className={`${styles.actionButtonLarge} ${styles.actionButtonNeutral}`}
        startIcon={<CancelIcon />}
        onClick={handleCancelOrder}
      >
        Order Cancellation
      </SecondaryButton>
    </>
  );
};

export default OrderManagementCard;
